import type { ReactNode } from "react";

export type ResponsiveLayout = "desktop" | "portrait" | "landscape";

// Kept with the shell so its responsive contract remains testable alongside the component.
// eslint-disable-next-line react-refresh/only-export-components
export function resolveResponsiveLayout(width: number, height: number): ResponsiveLayout {
  if (width >= 1024) return "desktop";
  return width > height ? "landscape" : "portrait";
}

interface AppShellProps {
  header: ReactNode;
  leftRail: ReactNode;
  map: ReactNode;
  inspector: ReactNode;
  timeline: ReactNode;
  layout: ResponsiveLayout;
  mobileNavigationOpen?: boolean;
  onMobileNavigationClose?: () => void;
}

export function AppShell({
  header,
  leftRail,
  map,
  inspector,
  timeline,
  layout,
  mobileNavigationOpen = false,
  onMobileNavigationClose,
}: AppShellProps) {
  const mobileRailOpen = layout !== "desktop" && mobileNavigationOpen;
  return (
    <main
      aria-label="台风追踪工作区"
      className={`app-shell app-shell--${layout}`}
      data-layout={layout}
    >
      <header className="app-shell__header">{header}</header>
      <aside
        aria-hidden={layout !== "desktop" && !mobileRailOpen}
        aria-label="台风信息与图层导航"
        className={`app-shell__rail${mobileRailOpen ? " app-shell__rail--open" : ""}`}
        id="typhoon-navigation"
      >
        {leftRail}
      </aside>
      {mobileRailOpen ? (
        <button
          aria-label="关闭台风导航"
          className="app-shell__nav-backdrop"
          onClick={onMobileNavigationClose}
          type="button"
        />
      ) : null}
      <section aria-label="台风路径地图" className="app-shell__map">
        {map}
      </section>
      <aside
        aria-label="城市天气底部面板"
        className={`app-shell__inspector inspector--${layout === "portrait" ? "sheet" : "split"}`}
      >
        {inspector}
      </aside>
      <section className="app-shell__timeline">{timeline}</section>
    </main>
  );
}
